import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#usePagination">usePagination(config)</a> ⇒ <inlineCode>Array.&lt;Object&gt;</inlineCode></dt>
      <dd>
        <p>{`A `}<a parentName="p" {...{
            "href": "https://reactjs.org/docs/hooks-intro.html"
          }}>{`React Hook`}</a>{` that provides
pagination logic.`}</p>
        <p>{`Use this hook to implement components that need to navigate through paged
data.`}</p>
      </dd>
    </dl>
    <p>{`The current pagination state`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`currentPage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The current page number`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`totalPages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The total number of pages`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The API object used for modifying the PaginationState.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#API"
        }}>{`API`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#API.setCurrentPage"
            }}>{`.setCurrentPage(page)`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#API.setTotalPages"
            }}>{`.setTotalPages(total)`}</a></li>
        </ul>
      </li>
    </ul>
    <p>{`Set the current page`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`page`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number to assign to the current page`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Set the total number of pages`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`total`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number to set the amount of pages available`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`A `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/hooks-intro.html"
      }}>{`React Hook`}</a>{` that provides
pagination logic.`}</p>
    <p>{`Use this hook to implement components that need to navigate through paged
data.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Array.<Object>`}</inlineCode>{`
— An array with two entries containing the following content: [ `}<a parentName="p" {...{
        "href": "#PaginationState"
      }}>{`PaginationState`}</a>{`, `}<a parentName="p" {...{
        "href": "#API"
      }}>{`API`}</a>{` ]`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object containing configuration values`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`config.namespace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`'`}{`'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace to append to config.parameter in the query. For example: ?namespace_parameter=value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`config.parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`'`}{`page`}{`'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the query parameter to use for page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`config.initialPage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The initial current page value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`config.initialTotalPages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The total pages expected to be usable by this hook`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/hooks/usePagination.js"
      }}>{`pwa-studio/packages/peregrine/lib/hooks/usePagination.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      